import { css } from "styled-components";

/**
 * Flex/text stack constraints so single-line ellipsis can shrink (KgDataSourceNodeCard pattern).
 */
export const kgNodeTextContainerStyles = css`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow: hidden;
`;

/** Single-line truncation for KG node titles and secondary labels. */
export const kgNodeEllipsisTextStyles = css`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/** Centered single-line truncation (circle, diamond, report body text). */
export const kgNodeEllipsisTextCenterStyles = css`
  ${kgNodeEllipsisTextStyles}
  text-align: center;
`;
